<template>
  <ErrorModal v-if="error.show" :data="error.data" :load-times="true" />
  <ContactModal
    v-if="showContact"
    :contactcar="contactCarGroup"
    @dismiss="showContact = false"
  />
  <reservationheader :step="1" />
  <reservationinfobar :step="1" @kmchange="loadCarGroup()" />

  <div class="orm-container-fluid orm-reservationCarselect">
    <div class="orm-container">
      <div class="orm-row">
        <div class="orm-col-xs-12">
          <div class="orm-row">
            <div class="orm-carfilter__element orm-col-xs-12 orm-col-sm-12">
              <filterSelect
                v-if="carGroup.length > 0 && !selectwait"
                :groupFilter="groupFilter"
                :preselect="selectedGroup"
                @update:dataPool="updateFilter"
              />
            </div>
            <!-- <div class="orm-carfilter__element orm-col-xs-12 orm-col-sm-3">
              <a href="#" class="orm-button__dropdown">Ausstattung</a>
            </div> -->
            <!-- <div class="orm-carfilter__element orm-col-xs-12 orm-col-sm-6">
              <form action="#">
                <input type="checkbox" id="test1" />
                <label for="test1">nur kontaktlos mieten</label>
                <a href="#" class="orm-carfilter__infolink"
                  ><i class="fal fa-question-circle"></i
                ></a>
              </form>
            </div> -->
          </div>
        </div>
      </div>

      <div class="orm-row">
        <div class="orm-col-xs-12">
          <div
            class="orm-row center-xs start-md"
            v-if="carGroup.length > 0 && !isLoading"
          >
            <Car
              v-for="car in carGroup"
              :key="car.id"
              :data="car"
              :filter="showCar(car.vehicle_category)"
              :availability-plan="availabilityPlan"
              :availability-check="availabilityCheck"
              :large="showLargeCarView"
              @openContact="openContact"
            />
          </div>
          <div
            class="text-center orm-mt-64 orm-mb-94"
            v-else-if="carGroup.length == 0 && !isLoading"
            v-html="i18n('step1/nocars')"
          ></div>
          <div
            class="orm-preload-page orm-preload-page-static orm-mt-64"
            v-else
          >
            <div class="orm-loader-spinner">
              <i class="fa fa-spinner-third orm-rotate360"></i>
            </div>
          </div>
          <div
            class="orm-col-xs-12 orm-background--white orm-py-30 orm-px-30"
            v-if="i18n('step1/description') && !isLoading && showSaleTax"
            v-html="i18n('step1/description')"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import { defineComponent } from "vue";
import reservationheader from "@/components/reservation/header.vue"; // @ is an alias to /src
import reservationinfobar from "@/components/reservation/infobar.vue"; // @ is an alias to /src
import Car from "@/components/cargroup/car.vue";

import filterSelect from "@/components/ui/filter-select.vue";
import ErrorModal from "@/components/modals/modal-error.vue";
import ContactModal from "@/components/modals/modal-contact.vue";

import store from "@/store";
import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
import { slugMe } from "@/constants/formater";
import i18n from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
export default defineComponent({
  name: "ReservationStep1",
  props: { data: Object, type: String },
  mixins: [i18n],
  data() {
    return {
      stationSelected: String,
      carGroup: [],
      groupFilter: [],
      selectwait: true,
      selectedAll: true,
      selectedGroup: {},
      contactCarGroup: {},
      isLoading: true,
      error: {
        show: false,
        data: {
          header: this.i18n("error/default/header"),
          content: this.i18n("error/default/content"),
          buttonFirst: "Home",
          buttonFirstLabel: this.i18n("error/default/buttonFirstLabel"),
        },
      },
      showContact: false,
      showSaleTax: false,
      showLargeCarView: false,
    };
  },
  components: {
    reservationheader,
    reservationinfobar,
    Footer,
    Car,
    filterSelect,
    ErrorModal,
    ContactModal,
  },
  async mounted() {
    const showTax = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_HIDE_TAX_TEXT"
    );

    switch (showTax) {
      case "1":
        this.showSaleTax = true;
        break;
      default:
        break;
    }
    const largeCarView = await store.getters["ORMgeneral/GET_PARAMETER"](
        "BORM_SHOW_LARGE_CAR_STEP1"
    );

    switch (largeCarView) {
      case "1":
        this.showLargeCarView = true;
        break;
      default:
        break;
    }
  },
  setup() {
    const stations = store.state.stations;
    let availabilityPlan = false;
    let availabilityCheck = false;
    if (
      store.getters["ORMgeneral/GET_MODULE"]("ORM_AVAILABILITY_PLAN") == "J"
    ) {
      availabilityPlan = true;
    }
    if (
        store.getters["ORMgeneral/GET_MODULE"]("ORM_AVAILABILITY_CHECK") == "J"
    ) {
      availabilityCheck = true;
    }
    if (process.env.VUE_APP_AVAILABILTYPLAN == "false") {
      availabilityPlan = false;
    }

    return {
      stations,
      store,
      availabilityPlan,
      availabilityCheck,
    };
  },
  async created() {
    this.stationSelected = await store.getters["userSession/GET_STATION"];

    if (this.stationSelected == null) {
      if (process.env.VUE_APP_STANDALONE == "true") {
        this.$router.push({ name: "Home" });
      } else {
        window.location.href = process.env.VUE_APP_BASE_URL;
      }
      return;
    }

    store.dispatch("reservation/DELETE_TARIF");
    store.dispatch("payment/DELETE_CONCARDIS");
    store.dispatch("reservation/DELETE_SUCCESS_RESERVATION");

    const branch = await store.getters["stations/GET_STATION_BY_ID"](
      this.stationSelected
    ).branch;
    if (
      (branch == "Auto-Abo" &&
        this.$route.name != "Abo_Step1" &&
        this.$route.name != "Abo_Step1_Selected") ||
      (branch != "Auto-Abo" &&
        this.$route.name != "Reservation_Step1" &&
        this.$route.name != "Reservation_Step1_Selected")
    ) {
      if (process.env.VUE_APP_STANDALONE == "true") {
        this.$router.push({ name: "Home" });
      } else {
        window.location.href = process.env.VUE_APP_BASE_URL;
      }
    }

    await this.loadCarGroup();
    buildDataLayer("view_item_list", {}, null);
    store.watch(
      (state, getters) => getters["userSession/GET_RESERVATIONTIME_START"],
      () => {
        this.loadCarGroup();
      }
    );
    store.watch(
      (state, getters) => getters["userSession/GET_RESERVATIONTIME_END"],
      () => {
        this.loadCarGroup();
      }
    );

    store.watch(
      (state, getters) => getters["userSession/GET_RESERVATIONDATE_START"],
      () => {
        this.loadCarGroup();
      }
    );
    store.watch(
      (state, getters) => getters["userSession/GET_RESERVATIONDATE_END"],
      () => {
        this.loadCarGroup();
      }
    );

    store.watch(
      (state, getters) => getters["userSession/GET_STATION_END"],
      () => {
        this.loadCarGroup();
      }
    );
  },
  methods: {
    async loadCarGroup() {
      this.isLoading = true;
      this.stationSelected = await store.getters["userSession/GET_STATION"];
      this.carGroup = [];

      await store
        .dispatch("cargroup/GET_CARGROUP_FROM_STATION", this.stationSelected)
        .then((res) => {
          const object = res;
          for (const key in object) {
            if (Object.prototype.hasOwnProperty.call(object, key)) {
              const element = object[key];
              object.find((x) => x.id === element.id).price = [];
            }
          }
          this.carGroup = object;
          this.isLoading = false;
        });

      this.groupFilter = await store.getters["cargroup/GET_GROUPFILTER"];
      if (this.$route.params.name) {
        const kfzcategories = this.$route.params.name.split("+");
        if (kfzcategories.length > 1) {
          for (const key in kfzcategories) {
            if (Object.hasOwnProperty.call(kfzcategories, key)) {
              const kfzcategory = kfzcategories[key];
              if (
                this.groupFilter.find(
                  (element) => slugMe(element) == kfzcategory
                )
              ) {
                this.selectedGroup[
                  this.groupFilter.find(
                    (element) => slugMe(element) == kfzcategory
                  )
                ] = true;
              }
            }
          }
          store.dispatch("userSession/SET_CARCATEGORY", this.selectedGroup);
          this.selectedAll = false;
          this.selectwait = false;
        } else if (
          this.groupFilter.find(
            (element) => slugMe(element) == this.$route.params.name
          )
        ) {
          this.selectedGroup[
            this.groupFilter.find(
              (element) => slugMe(element) == this.$route.params.name
            )
          ] = true;
          store.dispatch("userSession/SET_CARCATEGORY", this.selectedGroup);
          this.selectedAll = false;
          this.selectwait = false;
        }
      } else {
        this.selectedGroup = await store.getters["userSession/GET_CARCATEGORY"];
        if (Object.keys(this.selectedGroup).length) {
          this.selectedAll = false;
        }
        this.selectwait = false;
      }
    },

    showCar(group) {
      let hasfilter = false;
      if (group.length == 0 && this.selectedAll) return true;
      group.forEach((element) => {
        if (this.selectedGroup[element.id] || this.selectedAll) {
          hasfilter = true;
          return true;
        }
      });
      return hasfilter;
    },
    updateFilter(ev) {
      this.selectedGroup = ev.selectedGroup;
      this.selectedAll = ev.selectedAll;
    },
    showError(ev) {
      console.log(ev);
      this.error.show = true;
      //this.error.data.content = ev.form.message;
    },
    openContact(car) {
      this.contactCarGroup = car;
      this.showContact = true;
    },
  },
});
</script>
